export default "__VITE_ASSET__a1239ec8__"